import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const CaptionText = styled(Typography)({
	color: '#565656',
	fontSize: '14px',
	fontStyle: 'italic',
	fontWeight: 400,
});

export default CaptionText;
